import { Clock } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const ComingSoonOverlay = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-background/60">
    <span className="text-warning-foreground text-sm font-semibold tracking-widest uppercase">
      Coming Soon
    </span>
  </div>
);

export const ComingSoonNotice = () => (
  <Alert variant="warning">
    <Clock />
    <AlertTitle>Coming soon</AlertTitle>
    <AlertDescription>
      This dataset has been announced but is not yet available. The details
      below may change before its first release.
    </AlertDescription>
  </Alert>
);
